// extracted by mini-css-extract-plugin
export default {"headline":"ContentListModalHeadline-module__headline--e7ZRH","content":"ContentListModalHeadline-module__content--i2GoA"};